<template>
  <v-dialog
    v-model="dialog"
    :width="dialogWidth"
    transition="fade-transition"
    :scrollable="true"
  >
    <v-card>
      <v-card-title class="headline"><v-icon left>{{getSocialiteIcon(externalAccount.driver)}}</v-icon>{{ $t("socialiteDetailsDialog.title") }}</v-card-title>
      <v-card-text>
        <div class="pb-2">
          
        </div>
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <span>{{$t("socialiteDetailsDialog.description", {name: getSocialiteName(externalAccount.driver)})}}</span>
            </v-col>
            <v-col cols="4">
              <span>{{$t("socialiteDetailsDialog.nickname")}}</span>
            </v-col>
            <v-col cols="8">
              <span>{{externalAccount.nickname}}</span>
            </v-col>

            <v-col cols="4">
              <span>{{$t("socialiteDetailsDialog.url")}}</span>
            </v-col>
            <v-col cols="8">
              <socialite-open-button :externalAccount="externalAccount"/>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" class="error" text @click="disconnect()">
          <v-icon left>mdi-lan-disconnect</v-icon>{{ $t("socialiteDetailsDialog.disconnect") }}
        </v-btn>
        <v-btn :disabled="loading" class="primary" text @click="close()">
          <v-icon left>mdi-close</v-icon>{{ $t("common.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import socialiteMixin from "@/mixins/socialiteMixin"
import {
  MUTATION_PROFILE_LOADED,
} from "@/plugins/store";
import SocialiteOpenButton from './SocialiteOpenButton.vue';

export default {
  components: { SocialiteOpenButton },
  name: "SocialiteDetailsDialog",
  mixins: [socialiteMixin],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
    externalAccount: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      loading: false,
      dialog: false,
    };
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.closeAction();
      }
    },
  },
  computed: {
    dialogWidth: function () {
      if (this.$vuetify.breakpoint.smAndUp) {
        return "500";
      }
      return "90%";
    },
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    disconnect() {
      this.loading = true;
      this.$api
        .disconnectFromExternalAccount(this.externalAccount.driver)
        .then(res => {
          this.loading = false;
          this.$store.commit(MUTATION_PROFILE_LOADED, res.data);
          this.close()
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        })
    },
    close() {
      this.$emit("input", null);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
</style>